import { render, staticRenderFns } from "./PrivacyTermIframe.vue?vue&type=template&id=76a4b8d6"
import script from "./PrivacyTermIframe.vue?vue&type=script&lang=js"
export * from "./PrivacyTermIframe.vue?vue&type=script&lang=js"
import style0 from "./Term.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports